import React, { useEffect, useState } from "react";

import { Layout } from "../../components/layout";
import { Slider } from "../../components/slider";
import { ProjectItemsGroup } from "../../components/project-items-group";
import { HowWeHelpItemsGroup } from "../../components/how-we-help-items-group";
import { NewsEventsItemsGroup } from "../../components/news-events-items-group";
import { Classroom } from "../../components/classroom";

import { Cover } from "./cover";
import { APIS } from "../admin/common";
import { get } from "../../common/request";
import dayjs from "dayjs";
import { Container } from "react-bootstrap";
import { useWindowSize } from "../../hooks/use-device-type";

export function Main() {
  const [items, setItems] = useState([]);
  const [projectItems, setProjectItems] = useState([
    {
      title: "全球认可",
      description:
        "我们被公认为国际领先的人工智能测试中心，始终如一地提供高质量的服务及认证系统的效率、性能和完整性。我们强大的评估模型，由国际领先的专家开发，反映现实世界的场景，提供一个真实的测试环境。这种严格的测试方法确保我们评估的所有智能系统都准备好迎接并超越它们面临的挑战。",
      image: "/public/普尔文奖状.jpg",
      link: "https://waysglob.com/article.html?id=9"
    },
    {
      title: "国际认证",
      description:
        "我们以提供全球认证测试而自豪，与国际权威机构密切合作，确保我们的测试符合全球标准。我们卓越的声誉反映在我们赢得了世界各地认证机构的信任和尊重。",
      image: "/public/640.png",
      link: "https://waysglob.com/article.html?id=10"
    },
    {
      title: "高端猎聘",
      description:
        "我们的智库服务是一个智力探索的中心，来自不同学科的专家和专业人士在这里合作，在测试、认证和数字教育领域产生新的想法，进行研究，并开发创新的解决方案，推动创新和思想领导力。",
      image: "/public/HR.png",
      link: "https://waysglob.com/article.html?id=11"
    }
  ]);

  const [modules, setModules] = useState([]);

  useEffect(() => {
    get(APIS.PROJECT_LIST_SIMPLIFIED, { type: "news-events" }).then((res) => {
      setItems(
        res.data.slice(0, 4).map((item) => ({
          title: item.title,
          time: dayjs(item.createdAt).format("YYYY-MM-DD"),
          image: item.coverImageUrl,
          // link: `/article.html?id=${item.id}`
          link: item.externalLinkUrl || `/article.html?id=${item.id}`
        }))
      );
    });

    get(APIS.MODULE_LIST_SIMPLIFIED).then((res) => {
      setModules(res.data);
    });
  }, []);

  const { width } = useWindowSize();
  const isMobile = width <= 512;
  const isTablet = width <= 1024;
  const itemsNum = isMobile ? 1 : isTablet ? 2 : 4;
  // console.log("itemsNum", itemsNum);
  return (
    <div className="waysglob-index">
      <Cover />

      <Layout>
        <Slider />
        <ProjectItemsGroup items={projectItems} />
        <HowWeHelpItemsGroup />
        <Container>
          <NewsEventsItemsGroup
            items={items.slice(0, itemsNum)}
            wrapperStyle={{ flexWrap: "nowrap", gap: "1rem" }}
          />
        </Container>

        <div style={{ backgroundColor: "#fafafa", paddingBottom: "2rem" }}>
          <Classroom />

          {/* Custom Modules */}
          {modules.map((module, index) => {
            const moduleItems = module.moduleItems.map((item) => ({
              title: item.title,
              time: dayjs(item.createdAt).format("YYYY-MM-DD"),
              image: item.coverImageUrl,
              link: item.url
            }));

            return (
              <Container>
                <NewsEventsItemsGroup
                  key={index}
                  items={moduleItems}
                  title={module.name}
                  loadMoreLink={"/modules.html?id=" + module.id}
                />
              </Container>
            );
          })}
        </div>
      </Layout>
    </div>
  );
}
